// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__oUIET","left-panel":"Layout_left-panel__KPr8C","right-panel":"Layout_right-panel__crMkk","right-panel-full":"Layout_right-panel-full__wLSiI"};